import type {
  ActivityEventDto,
  ActivityEventType,
  ActivityFeedItemDto,
} from '@splitfiesta/shared';

/** The feed sentence for each event type; a type missing here is not drawn. */
export const ACTIVITY_EVENT_KEYS: Record<ActivityEventType, string> = {
  group_pro_added: 'dashboard:activityFeed.event.proAdded',
  group_pro_removed: 'dashboard:activityFeed.event.proRemoved',
  line_items_claimed: 'dashboard:activityFeed.event.lineItemsClaimed',
};

/**
 * Stands in for the actor's name when the sentence is translated, so each
 * locale places the name, which carries its own weight and badge.
 */
export const ACTIVITY_EVENT_NAME_MARKER = '\u0000actor\u0000';

export type GroupEventFeedItem = ActivityFeedItemDto & {
  event: ActivityEventDto;
};

/**
 * A group event this bundle can draw. The type is read as a plain string
 * because a newer server can send one the union does not have yet.
 */
export function isGroupEventItem(
  activity: ActivityFeedItemDto
): activity is GroupEventFeedItem {
  const type: string | undefined = activity.event?.type;
  return (
    activity.type === 'group_event' &&
    type !== undefined &&
    Object.prototype.hasOwnProperty.call(ACTIVITY_EVENT_KEYS, type)
  );
}

/**
 * Whether a feed item can be drawn. A group event without its payload, or of
 * a kind this build does not know, is dropped before the list renders, so
 * the first and last rows, the scroll ref and the empty state stay right.
 */
export function isRenderableActivity(activity: ActivityFeedItemDto): boolean {
  return activity.type !== 'group_event' || isGroupEventItem(activity);
}
